import { Link } from "react-router-dom";
import img1 from "../../assets/Images/Event Booking/Availability popup.png"
import img2 from "../../assets/Images/Event Calender/Event-Calender.png"
import DocNavigation from "../../components/DocNavigation";

export default function PreventDoubleBookings() {
    return (
        <section className="space-y-10">

            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-4">
                    Prevent Double Bookings
                </h1>

                <p className="text-md text-slate-600 max-w-4xl">
                    Double bookings are one of the most damaging mistakes in banquet and
                    event management. EventFlow prevents booking conflicts by enforcing
                    real-time availability checks across halls, dates, and time slots.
                </p>

                <section className="border-l border-[#C9A24E] pl-4 mt-6">
                    <h2 className="text-lg font-semibold mb-3">Overview</h2>
                    <p className="text-slate-600 text-sm">
                        Every booking is validated against the system calendar before it is
                        saved. This ensures that no hall or slot is booked twice.
                    </p>
                </section>
            </section>

            <section className="bg-slate-100 rounded-xl p-8 ">
                <h3 className="font-semibold mb-4">Why Double Bookings Happen?</h3>
                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>Manual date checking</li>
                    <li>Lack of centralized calendars</li>
                    <li>Multiple staff members booking simultaneously</li>
                </ul>
            </section>

            <section className="p-8">
                <div>
                    <h3 className="font-semibold mb-3">EventFlow’s Conflict Prevention</h3>
                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Slot-based booking validation</li>
                        <li>Hall-level availability tracking</li>
                        <li>Calendar-driven visibility</li>
                        <li>Automatic booking locks</li>
                    </ul>
                </div>

                <div className="rounded-lg p-6 flex justify-center items-center gap-10">
                    <img src={img1} alt="" className="w-2/5 h-auto shadow-lg" />
                    <img src={img2} alt=""  className="w-1/2 h-auto shadow-lg" />
                </div>
            </section>

            <section className="bg-slate-100 rounded-xl p-8">
                <p className="text-slate-600 max-w-4xl">
                    By preventing double bookings, EventFlow protects business reputation,
                    avoids customer disputes, and ensures smooth event execution.
                </p>
            </section>

            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, continue to the{" "}
                    <Link
                        to="/docs/financial-insights"
                        className="font-medium text-[#C9A24E]"
                    >
                        Real-time Financial Insights
                    </Link>.
                </p>
            </section> */}

            <DocNavigation
                previous={{
                    title: "Eliminate Manual Registers",
                    link: "/docs/no-registers"
                }}
                next={{
                    title: "Real-time Financial Insights",
                    link: "/docs/financial-insights"
                }}
            />
        </section>
    );
}
